import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/marketing")({
  component: () => <Outlet />,
});

